// Exit-intent: mostra o modal "Quero ser cliente" quando o visitante dá o
// sinal clássico de que vai sair (mouse sobe em direção à barra do navegador).
//
// Só desktop, de propósito: no mobile não existe um gesto equivalente sem
// mexer no histórico do navegador (pushState/popstate), e o site usa
// vue-router em modo history — interceptar o botão "voltar" colidiria com
// o próprio roteador e arriscaria quebrar a navegação em todo o site.
//
// Limitado a 1x por dia por navegador (localStorage), pra não repetir a
// cada visita/aba e virar irritação.

const CHAVE_ULTIMA_EXIBICAO = 'creditall_exit_intent_last_shown';
const INTERVALO_MS = 24 * 60 * 60 * 1000; // 24h

function jaMostrouRecentemente() {
  try {
    const ultimo = localStorage.getItem(CHAVE_ULTIMA_EXIBICAO);
    if (!ultimo) return false;
    return Date.now() - Number(ultimo) < INTERVALO_MS;
  } catch (e) {
    return false; // sem storage: deixa mostrar (best-effort, sem travar a feature)
  }
}

function marcarExibido() {
  try {
    localStorage.setItem(CHAVE_ULTIMA_EXIBICAO, String(Date.now()));
  } catch (e) {
    // best-effort
  }
}

function ehProvavelDesktop() {
  try {
    const semToque = !('ontouchstart' in window) && navigator.maxTouchPoints === 0;
    return semToque && window.innerWidth >= 992;
  } catch (e) {
    return false;
  }
}

// Registra o gatilho e chama `onTrigger()` no máximo 1x por dia, na
// primeira vez que o mouse sair pela borda superior da janela.
// Retorna uma função para desmontar o listener.
export function iniciarExitIntent(onTrigger) {
  if (!ehProvavelDesktop() || jaMostrouRecentemente()) {
    return () => {};
  }

  let disparado = false;

  function aoMouseSair(evento) {
    if (disparado || evento.clientY > 0) return;
    disparado = true;
    marcarExibido();
    onTrigger();
    document.removeEventListener('mouseout', aoMouseSair);
  }

  document.addEventListener('mouseout', aoMouseSair);
  return () => document.removeEventListener('mouseout', aoMouseSair);
}
